var _rect, _line, _line2, _line3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 18.5,
    rx: 3.25,
    stroke: "#565D6D",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 12.25,
    x2: 14.25,
    y2: 12.25,
    stroke: "#565D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 7.4,
    x2: 13.4,
    y2: 7.4,
    stroke: "#565D6D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 15.25,
    x2: 14.25,
    y2: 15.25,
    stroke: "#565D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60323 4.00945C5.76755 4.10109 5.85791 4.16687 5.9626 4.3239C5.9626 4.3832 5.9626 4.4425 5.9626 4.50359C6.00488 4.50151 6.04715 4.49942 6.0907 4.49727C6.60461 4.48238 6.60461 4.48238 6.76278 4.58782C6.90077 4.72188 6.91549 4.80152 6.92281 4.98931C6.92176 5.1708 6.91543 5.21014 6.79927 5.35991C6.62632 5.48757 6.53887 5.4979 6.32531 5.50135C6.24518 5.50326 6.24518 5.50326 6.16344 5.50521C6.05067 5.50754 5.9379 5.50953 5.82512 5.51118C5.74473 5.51326 5.74473 5.51326 5.66272 5.51539C5.58912 5.51672 5.58912 5.51672 5.51403 5.51808C5.36137 5.53918 5.27709 5.58005 5.15401 5.67156C5.04169 5.84004 5.04009 5.92126 5.06417 6.12078C5.22854 6.3295 5.35834 6.37776 5.61727 6.41558C6.03371 6.48543 6.39158 6.61695 6.65486 6.96921C6.84259 7.25655 6.92363 7.51892 6.92281 7.86431C6.92274 7.89601 6.92266 7.9277 6.92259 7.96036C6.91641 8.2239 6.86328 8.41413 6.72628 8.6364C6.70219 8.68273 6.6781 8.72906 6.65328 8.77678C6.49842 8.96424 6.30889 9.10103 6.09737 9.22039C6.0529 9.22039 6.00842 9.22039 5.9626 9.22039C5.96955 9.27876 5.96955 9.27876 5.97664 9.33831C5.95727 9.54753 5.88332 9.61066 5.738 9.75945C5.59256 9.83217 5.44597 9.83004 5.28878 9.80437C5.16583 9.74329 5.11424 9.68634 5.01925 9.57976C4.98959 9.43693 4.98959 9.43693 4.97432 9.31023C4.92829 9.31232 4.88225 9.3144 4.83482 9.31655C4.7737 9.31824 4.71257 9.31987 4.65145 9.32146C4.62119 9.32297 4.59093 9.32447 4.55976 9.32602C4.39526 9.32923 4.30851 9.31541 4.16906 9.2253C4.00798 9.06149 4.01339 8.92517 4.015 8.70308C4.03096 8.59148 4.03096 8.59148 4.13485 8.45391C4.31395 8.32479 4.44695 8.31563 4.6625 8.3109C4.71598 8.30942 4.76946 8.30794 4.82455 8.30642C4.93732 8.30368 5.0501 8.3011 5.16287 8.2987C5.24318 8.2964 5.24318 8.2964 5.3251 8.29405C5.37411 8.29292 5.42313 8.2918 5.47363 8.29064C5.60088 8.27728 5.67609 8.25577 5.78292 8.18719C5.88649 8.04218 5.8873 7.91246 5.87276 7.73797C5.83444 7.62302 5.80908 7.5743 5.70553 7.5109C5.58547 7.46106 5.47661 7.44564 5.34774 7.42913C4.8713 7.35329 4.50566 7.16704 4.2182 6.77109C3.97963 6.36324 3.95233 5.91191 4.06097 5.45572C4.21169 5.0753 4.51756 4.76888 4.88448 4.59344C4.91413 4.59344 4.94378 4.59344 4.97432 4.59344C4.96876 4.53368 4.96876 4.53368 4.96309 4.47271C4.97693 4.28936 5.02551 4.2278 5.15401 4.09929C5.30088 3.99649 5.42668 3.98826 5.60323 4.00945Z",
    fill: "#565D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceListing);
export default __webpack_public_path__ + "static/media/invoice-listing.6c80b3e43da0a68304074528a932a4e6.svg";
export { ForwardRef as ReactComponent };